var View;

(function (View) {
  View["Desktop"] = "desktop";
  View["Mobile"] = "mobile";
})(View || (View = {}));

export { View };
